import React from "react";

export default function OneVehicle() {
  return <div>OneVehicle</div>;
}
